import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { Form, useActionData, useNavigate, useNavigation } from "react-router-dom";
import { getRandomImages } from "router/actions";
import { ToastContainer } from "react-toastify";
import AppNavigation from "router/AppNavigation";

export default function Login() {
    const navigation = useNavigation();
    const inputDisabled = navigation.state === "submitting";
    const error = useActionData() as string | undefined;

    // haandle sign up events
    const navigate = useNavigate();
    const handleSignUpClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        navigate(AppNavigation.Register);
    };

    // ========================== Get random images =========================
    const [images, setImages] = useState("");
    useEffect(() => {
        const fetchImages = async () => {
            const imagesUrls = await getRandomImages();
            console.log(imagesUrls);
            setImages(imagesUrls);
            console.log(imagesUrls);
        };
        fetchImages();
    }, []);

    return (
        <Grid container component="main" sx={{ height: "100vh" }}>
            <CssBaseline />
            {
                images.length > 0 && (
                    <Grid
                        item
                        xs={false}
                        sm={4}
                        md={7}
                        sx={{
                            backgroundImage: `url(${images})`,
                            backgroundRepeat: "no-repeat",
                            backgroundColor: (t) =>
                                t.palette.mode === "light"
                                    ? t.palette.grey[50]
                                    : t.palette.grey[900],
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            xs: { display: "none" }
                        }}
                    />
                )
            }

            {/* =============================== CONTROL FORM ==================================== */}
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        mx: 6,
                        // my: 8,
                    }}
                >
                    <Typography component="h1" variant="h5">
                        LOGIN
                    </Typography>

                    {/* Login form */}
                    <Box component={Form} method="post" sx={{ mt: 1 }}>
                        {/* Email input */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                            disabled={inputDisabled}
                        />

                        {/* Password input */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            disabled={inputDisabled}
                        />

                        {/* Remember me checkbox */}
                        <FormControlLabel
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                            disabled={inputDisabled}
                        />

                        {/* Message toast */}
                        <ToastContainer />


                        {/* Sign up link */}
                        {/* <Typography variant="body2">
                            Don't have an account?{" "}
                            <a href="#" onClick={handleSignUpClick} style={{ fontWeight: 500 }}>
                                Sign Up
                            </a>
                        </Typography> */}

                        {/* Login button */}
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2, height: 40 }}
                            disabled={inputDisabled}
                        >
                            <Box
                                sx={{
                                    height: 24,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {inputDisabled ? <CircularProgress size={16} /> : "Login"}
                            </Box>
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
}
